import { Directive, ElementRef, HostListener, Renderer2, Input } from '@angular/core';

@Directive({
    selector: '[sizeContainer]',
})
export class ElementCardsDirective {

    @Input() public totalCards: number = 0;
    public nativeElement: HTMLInputElement;

    private domObserver;

    constructor(
        public element: ElementRef,
        public render: Renderer2,
    ) {
        this.nativeElement = this.element.nativeElement;

        this.domObserver = new MutationObserver((mutations) => {
            mutations.forEach(() => {
                this.calculateCards();
            });
        });
        this.domObserver.observe(this.nativeElement, { childList: true });
    }

    @HostListener('window:resize', ['$event'])
    public onScroll(event) {
        this.calculateCards();
    }

    public calculateCards() {
        this.nativeElement.classList.remove('stock-container--two', 'stock-container--three');
        const windowSize = window.document.body.clientWidth;

        if (windowSize >= 1440) {
            if ((this.totalCards % 4) === 2) {
                this.nativeElement.classList.add('stock-container--two');
            } else if ((this.totalCards % 4) === 3) {
                this.nativeElement.classList.add('stock-container--three');
            } else {
                this.nativeElement.classList.remove('stock-container--two');
                this.nativeElement.classList.remove('stock-container--three');
            }
        } else {
            if ((this.totalCards % 3) === 2) this.nativeElement.classList.add('stock-container--two');
        }
    }
}
